"use client";

import { ArrowLeft } from "lucide-react";

export function BackButton() {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <button onClick={handleGoBack} className="w-full sm:w-auto group">
      <div className="bg-white hover:bg-gray-50 text-navigator-primary rounded-2xl transition-all duration-300 shadow-md hover:shadow-xl border-2 border-navigator-primary/20 hover:border-navigator-primary/40">
        <div className="flex items-center justify-center gap-3 px-8 py-4">
          <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
          <span className="font-semibold text-lg">Go Back</span>
        </div>
      </div>
    </button>
  );
}
